import { CONTROLLERS_ROUTE, EVENT_LOG_ROUTE } from "@/router/names";

import ControllersList from "@/views/devices/ControllersList";
import EventLog from "@/views/EventLog";

export const controllerRoutes = [
  {
    path: "/controllers",
    name: CONTROLLERS_ROUTE,
    component: ControllersList,
    meta: {
      type: "controllers",
      group: "Управление устройствами",
      title: "Контроллеры",
      icon: "mdi-developer-board",
      linked: true,
      breadcrumbs: [
        {
          text: "Главная",
          link: true,
          exact: true,
          to: { name: "home" }
        },
        {
          text: "Контроллеры",
          disabled: true,
          link: true,
          to: { name: CONTROLLERS_ROUTE }
        }
      ]
    }
  },
  {
    path: "/event-log",
    name: EVENT_LOG_ROUTE,
    component: EventLog,
    meta: {
      group: "Управление устройствами",
      title: "Лог событий",
      icon: "mdi-text-box-search-outline",
      linked: true,
      breadcrumbs: [
        {
          text: "Главная",
          link: true,
          exact: true,
          to: { name: "home" }
        },
        {
          text: "Лог событий",
          disabled: true,
          link: true,
          to: { name: EVENT_LOG_ROUTE }
        }
      ]
    }
  }
];
